<template>
  <v-card class="pa-3 overflow-auto" width="100vw" max-width="850" max-height="100vh">
    <v-row class="align-start">
      <v-col cols="12" xxl="8" xl="8" lg="8" md="8" sm="8">
        <v-card>
          <card-header></card-header>
          <dynamic-information v-model:carts="cart"></dynamic-information>
        </v-card>
      </v-col>

      <v-col class="sticky" cols="12" xxl="4" xl="4" lg="4" md="4" sm="4">
        <cart-detail></cart-detail>
      </v-col>
    </v-row>

    <v-divider class="border-opacity-50 mt-4" thickness="2"></v-divider>

    <v-card-item>
      <card-footer></card-footer>
    </v-card-item>
  </v-card>
</template>

<script>
import DynamicInformation from "@/components/customer-information/DynamicInformation.vue"
import { category } from "@/config/productCategory";
import CardFooter from "@/components/footer/CardFooter.vue";
import CartDetail from "@/components/cart-detail/CartDetail.vue";
import CardHeader from "@/components/header/CardHeader.vue";

export default {
  components: {
    CardFooter,
    CartDetail,
    DynamicInformation,
    CardHeader
  },
  computed: {
    cart() {
      return this.$store.getters.sortedCartByTypeID;
    },
  },
  data() {
    return {
      product: this.$store.state.product,
      CATEGORY: category,
    };
  },
};
</script>

<style></style>